import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import HCaptcha from '@fuww/library/src/Captcha';
import { Controller } from 'react-hook-form';
import { useSiteContext } from './SiteContext';

const Captcha = React.forwardRef(
  (properties, reference) => {
    const { production } = useSiteContext();

    return (
      <HCaptcha
        {...properties}
        sitekey={production
          ? '3bbd4a2a-9535-4995-9e8d-41d7a57b2ee7'
          : '10000000-ffff-ffff-ffff-000000000001'}
        ref={reference}
      />
    );
  },
);

export const CaptchaWithController = React.forwardRef(
  ({
    rules,
    name,
    control,
    defaultValue,
    ...properties
  }, reference) => {
    const render = useCallback(
      ({
        onChange, onBlur, value,
      }) => (
        <Captcha
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          ref={reference}
          {...properties}
        />
      ),
      [reference, properties],
    );
    return (
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        render={render}
      />
    );
  },
);

CaptchaWithController.propTypes = {
  rules: PropTypes.shape({}),
  name: PropTypes.string.isRequired,
  control: PropTypes.shape({}).isRequired,
  defaultValue: PropTypes.string,
};

CaptchaWithController.defaultProps = {
  defaultValue: '',
  rules: {},
};

export default Captcha;
